import { writable } from 'svelte/store';

import { Currency } from '../utils/currency';

export const currency = writable<Currency>(Currency.EUR);
export const exchangeRate = writable(1.0);
